<template lang="pug">
v-menu(v-model="showMenu" offset-y rounded="lg" max-width="1000" :close-on-content-click="false" max-height="450" nudge-bottom="4")
  template(v-slot:activator="{ on }")
    div(v-on="on")
      y-button(:label="getButtonText" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" prepend-icon="$yzi-calendar" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2")
  .white
    v-row(no-gutters)
      v-col(cols="4")
        .d-flex
          v-radio-group.ma-0.flex-grow-1(v-model="radioGroup" mandatory @change="setDateRange(radioGroup)")
            template(v-for="option in options")
              v-radio.px-4.py-2.my-0(:value="option.id")
                template(v-slot:label)
                  .text-sm.font-normal.primary--text.mt-1 {{ option.name }}
              v-divider.basic300

          v-divider.basic300(vertical)
      v-col(cols="8")
        v-card(flat width="650" height="445")
          //- visits
          template(v-if="radioGroup === 'visit'")
            div.pa-4
              div.d-flex.align-center
                div.text-md.font-semibold Select visit
                v-spacer
                y-button(label="Reset" underline size="xs" unset-min-width button-class="px-0" @click="resetFilter(true)")
                y-button.ml-6(label="Apply" size="xs" button-class="px-2" @click="applyFilter")
              v-divider.my-3
              visit-history-selection(ref="visitselection")
          //- dates
          template(v-else)
            v-card(flat)
              div.d-flex.align-center.pa-4
                div.text-md.font-semibold {{ dateText }}
                v-spacer
                y-button(label="Reset" underline size="xs" unset-min-width button-class="px-0" @click="resetFilter")
                y-button.ml-8(label="Apply" size="xs" button-class="px-2" @click="applyFilter")
              v-divider.basic300
              yc-date-picker.range-date-picker(:parentDate.sync="selectedDates" range :readonly="readonly")
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import VisitHistorySelection from '@/components/clinic/consultation/VisitHistorySelection.vue'

export default {
  components: { VisitHistorySelection },
  props: {},
  data: () => ({
    showMenu: false,
    readonly: true,
    beginDate: null,
    untilDate: null,
    currentDateRange: null,
    radioGroup: null,
    selectedDates: null,
    selectedOption: null,
    buttonText: null,
    visits: [],
    options: [
      { id: 'visit', name: 'Select visit' },
      { id: 'lastSeven', name: 'Last 7 days' },
      { id: 'lastThirty', name: 'Last 30 days' },
      { id: 'lastNinety', name: 'Last 90 days' },
      { id: 'thisWeek', name: 'This week' },
      { id: 'thisMonth', name: 'This month' },
      { id: 'thisYear', name: 'This year' },
      { id: 'lastWeek', name: 'Last week' },
      { id: 'lastMonth', name: 'Last month' },
    ],
  }),
  computed: {
    ...mapGetters({
      visitFilters: 'treatment/getVisitFilters',
    }),
    getButtonText () {
      return this.buttonText || 'All visits'
    },
    dateText () {
      if (this.selectedDates && this.selectedDates.length > 0) {
        const start = this.selectedDates[0]
        let end = this.selectedDates[1]
        if (!end) {
          end = start
        }
        const dateFormat = 'd MMM yyyy'
        const startDate = DateTime.fromFormat(start, 'yyyy-MM-dd').toFormat(dateFormat)
        const endDate = DateTime.fromFormat(end, 'yyyy-MM-dd').toFormat(dateFormat)
        return `${startDate} - ${endDate}`
      }
      return '-'
    }
  },
  watch: {
    showMenu (val) {
      if (val) {
        this.setData()
      }
    }
  },
  mounted () {},
  methods: {
    setData () {
      this.radioGroup = this.selectedOption
      this.$nextTick(() => {
        if (this.radioGroup === 'visit') {
          this.$refs.visitselection.setData()
        }
      })
    },
    setDateRange(val) {
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      this.readonly = true
      switch (val) {
        case 'lastSeven': {
          const start = now.minus({ days: 6 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'lastThirty': {
          const start = now.minus({ days: 30 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'lastNinety': {
          const start = now.minus({ days: 90 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'thisWeek': {
          const start = now.startOf('week')
          const end = now.endOf('week')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'thisMonth': {
          const start = now.startOf('month')
          const end = now.endOf('month')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'thisYear': {
          const start = now.startOf('year')
          const end = now.endOf('year')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'lastWeek': {
          const lastWeek = now.minus({ weeks: 1 })
          const lastWeekStart = lastWeek.startOf('week')
          const lastWeekEnd = lastWeek.endOf('week')
          this.selectedDates = [lastWeekStart.toFormat(dateFormat), lastWeekEnd.toFormat(dateFormat)]
          break
        }
        case 'lastMonth': {
          const lastMonth = now.minus({ months: 1 })
          const lastMonthStart = lastMonth.startOf('month')
          const lastMonthEnd = lastMonth.endOf('month')
          this.selectedDates = [lastMonthStart.toFormat(dateFormat), lastMonthEnd.toFormat(dateFormat)]
          break
        }
        default:
          this.selectedDates = null
          break
      }
    },
    updateButtonText () {
      let text = 'All visits'
      if (this.radioGroup === 'visit') {
        if (this.visitFilters.visits && this.visitFilters?.visits.length > 0) {
          text = `${ this.visitFilters.visits.length} visit selected`
        }
      } else {
        let seletedOption = this.options.find(f => f.id === this.radioGroup)
        if (seletedOption) {
          text = seletedOption.name
        }
      }
      this.buttonText = text
    },
    updateFilters () {
      let obj = {
        visits: null,
        dateRange: this.selectedDates,
      }
      this.$store.commit('treatment/updateVisitFilters', obj)
    },
    applyFilter() {
      if (this.radioGroup === 'visit') {
        this.$refs.visitselection.updateFilters()
      } else {
        this.updateFilters()
      }
      this.selectedOption = this.radioGroup
      this.updateButtonText()
      this.$emit('change')
      this.showMenu = false
    },
    async resetFilter(uncheck) {
      this.radioGroup = 'visit'
      if (uncheck) {
        await this.$refs.visitselection.uncheckAllVisits()
      }
      await this.$store.commit('treatment/updateVisitFilters', { visits: null, dateRange: null })
      this.selectedOption = null
      this.$emit('change')
      this.buttonText = null
      this.showMenu = false
    },
  }
}
</script>

<style lang="scss">
.range-date-picker {

  .v-date-picker-table .v-btn.v-date-picker-table__current {
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #EEEEEE !important;
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active.v-date-picker--first-in-range, .v-btn.v-btn--active.v-date-picker--last-in-range {
    background-color: #333333 !important;
    .v-btn__content {
      color: #ffffff;
    }
  }

  .v-date-picker-table .v-btn {
    font-weight: 500;
    font-size: 16px !important;
  }

  .v-date-picker-table__current {
    border: 2px solid black !important;
  }
}
</style>